import { $ } from '../base/bootstrap';

export function initializeLotteriesButtonsNavigation(wrapperClassSelector = '.btn-nav-wrapper') {
    const $wrapper = $(wrapperClassSelector);

    if ($wrapper.length < 1) {
        return;
    }

    const $slider = $wrapper.find('.lottery-selection-slider');
    const $sliderNav = $wrapper.find('.lottery-selection-slider-nav');
    const $sliderWrapper = $wrapper.find('.lottery-selection-slider-wrapper');
    const $next = $sliderNav.find('.next');
    const $prev = $sliderNav.find('.prev');
    const $sliderItems = $slider.find('.slider-item');
    let sliderItemsWidth = 2;

    checkIfNavShouldBeDisplayed();
    $(window).on('resize orientationchange', function () {
        checkIfNavShouldBeDisplayed();
    });

    // Maximal slides change - next button press
    const maxSlidesChange = $sliderItems.length - 1;
    let stepsIterator = 0;
    let distance = 0;

    // Calculate and hide nav if there is no need to use it
    function checkIfNavShouldBeDisplayed() {
        // reset position of the slider
        $prev.hide();
        $next.show();
        $sliderWrapper.scrollLeft(0);
        $slider.css('transform', 'translateX(0px)');
        $sliderWrapper.removeClass('is-scrolled');

        sliderItemsWidth = 2;
        $sliderItems.each(function () {
            sliderItemsWidth += $slider.find(this).width();
        });

        $slider.width(sliderItemsWidth);

        if (sliderItemsWidth <= $sliderWrapper.width()) {
            $wrapper.removeClass('is-enabled');
        } else {
            $wrapper.addClass('is-enabled');
        }

        // Reset values before next change
        distance = 0;
        stepsIterator = 0;
    }

    $next.on('click', function () {
        $prev.show();
        if (stepsIterator + 1 > maxSlidesChange) {
            $(this).hide();
            return;
        }

        const itemWidth = $slider.find($sliderItems[stepsIterator]).outerWidth();
        if ((distance - itemWidth) * -1 < sliderItemsWidth) {
            distance -= itemWidth;

            if (stepsIterator === 0) {
                distance += $prev.outerWidth();
            }
        }
        stepsIterator++;
        $slider.css('transform', `translateX(${distance}px)`);
        $(this).show();

        if (stepsIterator + 1 > maxSlidesChange) {
            $(this).hide();
        }
    });

    $prev.on('click', function () {
        if (stepsIterator === 0) {
            return;
        }
        const itemWidth = $slider.find($sliderItems[--stepsIterator]).outerWidth();
        distance = stepsIterator === 0 ? 0 : distance + itemWidth;

        $slider.css('transform', `translateX(${distance}px)`);
        $(this).toggle(stepsIterator > 0);
        $next.show();
    });

    // Native scroll listener with passive: true
    $sliderWrapper[0]?.addEventListener(
        'touchmove',
        function () {
            if (this.scrollLeft > 0) {
                this.classList.add('is-scrolled');

                if (distance < 0) {
                    this.scroll({ left: distance * -1 });

                    distance = 0;
                    stepsIterator = 0;
                    $prev.hide();

                    $slider.css('transform', 'translateX(0px)');
                }
            } else {
                this.classList.remove('is-scrolled');
            }
        },
        { passive: true }
    );

    // jQuery fallback for mousewheel
    $sliderWrapper.on('mousewheel', function (event) {
        event.preventDefault();
    });
}

export function setupDataTable() {
    $(document).ready(function () {
        const $table = $('.article-main > table');
        if ($table.length === 0) {
            return;
        }
        $table.addClass('table table-striped');
    });
}
